/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.syncPull'

type $nsid = typeof $nsid

export { $nsid }

type Record$0 = {
  $type?: 'us.edriffles.radlib.private.syncPull#record'
  space: string
  repo: l.DidString
  collection: l.NsidString
  rkey: l.RecordKeyString
  cid: l.CidString
  record: l.LexMap
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
}

export type { Record$0 as Record }

const record$0 = /*#__PURE__*/ l.typedObject<Record$0>(
  $nsid,
  'record',
  /*#__PURE__*/ l.object({
    space: /*#__PURE__*/ l.string(),
    repo: /*#__PURE__*/ l.string({ format: 'did' }),
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
    rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    record: /*#__PURE__*/ l.lexMap(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { record$0 as record }

type Grant = {
  $type?: 'us.edriffles.radlib.private.syncPull#grant'
  id: string
  space: string
  targetPdsDid: l.DidString
  targetActorDid: l.DidString
  collection?: l.NsidString
  expiresAt: l.DatetimeString
  createdAt: l.DatetimeString
}

export type { Grant }

const grant = /*#__PURE__*/ l.typedObject<Grant>(
  $nsid,
  'grant',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    space: /*#__PURE__*/ l.string(),
    targetPdsDid: /*#__PURE__*/ l.string({ format: 'did' }),
    targetActorDid: /*#__PURE__*/ l.string({ format: 'did' }),
    collection: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'nsid' }),
    ),
    expiresAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { grant }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  grant: /*#__PURE__*/ l.string({ maxLength: 256 }),
  space: /*#__PURE__*/ l.string(),
  targetPdsDid: /*#__PURE__*/ l.string({ format: 'did' }),
  targetActorDid: /*#__PURE__*/ l.string({ format: 'did' }),
  collection: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'nsid' }),
  ),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 128 })),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  grant: /*#__PURE__*/ l.ref<Grant>((() => grant) as any),
  space: /*#__PURE__*/ l.string(),
  records: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Record$0>((() => record$0) as any),
    { maxLength: 100 },
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Pull private records over a direct PDS-to-PDS connection using a scoped capability. The response is never published to the public repository, Relay, or public AppView. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
